(() => {
  if (window.SpotmateDeferredSocialVideo) return;
  window.SpotmateDeferredSocialVideo = true;

  const trackActivation = (container) => {
    const provider = container.dataset.videoProvider || 'video';
    const payload = {
      video_provider: provider,
      video_id: container.dataset.videoId || '',
      origin_module: 'social_feeds',
      section_id: container.dataset.sectionId || '',
      block_id: container.dataset.blockId || '',
    };

    if (window.SpotmateTracking && typeof window.SpotmateTracking.push === 'function') {
      window.SpotmateTracking.push(
        'video_play',
        payload,
        {
          dedupeKey: `${provider}:${payload.video_id}`,
          dedupeWindowMs: 300000,
        },
      );
      return;
    }

    const trackingEvent = { event: 'video_play', ...payload };
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(trackingEvent);
    if (typeof window.spotmateGtmPush === 'function') window.spotmateGtmPush(trackingEvent);
  };

  const activatePlayer = (container, options = {}) => {
    if (!container || container.dataset.tiktokLoaded === 'true') return;

    const source = container.dataset.socialVideoSrc;
    if (!source) return;

    container.dataset.tiktokLoaded = 'true';

    const iframe = document.createElement('iframe');
    iframe.src = source;
    iframe.title = container.dataset.socialVideoTitle || 'Social video player';
    iframe.loading = 'eager';
    iframe.allow = 'autoplay; fullscreen; picture-in-picture';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    iframe.style.width = '100%';
    iframe.style.height = '100%';
    iframe.style.border = '0';

    container.replaceChildren(iframe);
    if (options.track) trackActivation(container);
  };

  const observePlayers = () => {
    const containers = Array.from(document.querySelectorAll('[data-deferred-social-video]'));
    if (!containers.length) return;

    if (!('IntersectionObserver' in window)) {
      activatePlayer(containers[0]);
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        const mostVisibleBySection = new Map();

        entries
          .filter((entry) => entry.isIntersecting && entry.intersectionRatio >= 0.01)
          .forEach((entry) => {
            const sectionId = entry.target.dataset.sectionId || 'global';
            const current = mostVisibleBySection.get(sectionId);
            if (!current || entry.intersectionRatio > current.intersectionRatio) {
              mostVisibleBySection.set(sectionId, entry);
            }
          });

        mostVisibleBySection.forEach((entry) => {
          observer.unobserve(entry.target);
          activatePlayer(entry.target);
        });
      },
      { rootMargin: '400px 0px', threshold: 0.01 },
    );

    containers.forEach((container) => observer.observe(container));
  };

  document.addEventListener(
    'click',
    (event) => {
      const control = event.target.closest('[data-social-video-play]');
      if (!control) return;

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
      activatePlayer(control.closest('[data-deferred-social-video]'), { track: true });
    },
    true,
  );

  const scheduleObservation = () => {
    requestAnimationFrame(() => {
      requestAnimationFrame(observePlayers);
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleObservation, { once: true });
  } else {
    scheduleObservation();
  }
})();
